<rask-container-block>
  <ng-container header>
    <rask-header size="2" underline>
      {{ 'TPL_TRANSPORTTILLDELA_HEADER' | translate }}
      @if (arbetsorders) {
        <span class="small-text">{{ nrOfSelectedAos }} av {{ arbetsorders.length }}
        valda</span>
      }
      <rask-button color="primary" [disabled]="!canTilldela || !canEdit" (click)="openDialog()"
        class="tilldelabtn">
      {{ 'TPL_TRANSPORTTILLDELA_TILLDELA' | translate }}</rask-button>
    </rask-header>
  </ng-container>

  @if (arbetsorders) {
    <div class="info-container">
      <rask-checkbox [(ngModel)]="allSelected" text="{{ 'TPL_LIST_SELECT_ALL' | translate }}"
      (checkedChange)="onAllSelectedChanged($event)" class="allCheckBox low"></rask-checkbox>
    </div>
  }

  <div>
    <div class="list-container">
      @for (arbetsorder of arbetsorders; track arbetsorder) {
        <div>
          <div class="row row-border"
            [ngClass]="{'red-back' : arbetsorder.warningEnabled && !arbetsorder.hasClickedWarning, 'ao-row-hover': arbetsorder.isHover }"
            (click)="arbetsorder.warningEnabled && !arbetsorder.hasClickedWarning && showValsInfo(arbetsorder.id)"
            (mouseover)="mouseOver(arbetsorder.id)"
            (mouseout)="mouseOut(arbetsorder.id)">
            <div class="col-10">
              @if(arbetsorder.hasBefraktare && arbetsorder.hasMultipleBefraktare){
                <div class="multipleBefraktareIcon"></div>
              }
              @else if(arbetsorder.hasBefraktare)
              {
              <div ngClass="diamond" [ngStyle]="{'background-color': arbetsorder.befraktareColors[0]}"></div>
            }
            @else if(!arbetsorder.isDelad)
            {
            <div [ngClass]="{'square': arbetsorder.isTerminalImport, 'dot': !arbetsorder.isTerminalImport}"
            [ngStyle]="{'background-color': arbetsorder.model.color}"></div>
          }
          @else if(arbetsorder.isDelad && !arbetsorder.isTerminalImport){
          <div class="deladAoIcon"><i class="fad fa-adjust"></i></div>
        }
        @else if(arbetsorder.isDelad && arbetsorder.isTerminalImport)
        {
        <div class="triangle" [ngStyle]="{'border-color': 'transparent transparent ' + arbetsorder.model.color + ' ' + arbetsorder.model.color}"></div>
      }
      <a href="" (click)="aoDetails($event, arbetsorder.id)">
        {{ arbetsorder.beteckning }} {{ arbetsorder.namn }}
      </a>
      @if (arbetsorder.warningEnabled) {
        <i
          class="fal fa-exclamation-square warning"
          placement="bottom"
          ngbTooltip="{{ 'TPL_TRANSPORTTILLDELA_VALSTOOLTIP' | translate }}">
        </i>
      }
    </div>
    <div class="col-2">
      <rask-checkbox (checkedChange)="onCheckedChanged($event)" class="checkbox low"
      [(ngModel)]="arbetsorder.selected"></rask-checkbox>
    </div>
    <div class="col-12 removePadding">
      <span class="newLine fw-bold small-text tf-padding">{{ arbetsorder.ansvarigtTransportforetag }}</span>
      @for (tf of arbetsorder.transportforetagList; track tf) {
        <span
        class="newLine small-text tf-padding">{{ tf }}</span>
      }
    </div>
  </div>
</div>
}
</div>
</div>
<ng-container footer></ng-container>
</rask-container-block>